import Vue from "vue";
import Router from "vue-router";
import Home from "./components/index.vue";
console.log("0000000000");
Vue.use(Router);
export const routes = [
  {
    path: "/",
    name: "advertise",
    component: () => import(`@/components/${process.env.VUE_APP_HOMEPAGE}.vue`),
    redirect: process.env.VUE_APP_REDIRECT,
  },
  {
    path: "/home",
    name: "home",
    component: Home,
    redirect: "/home/homeMiddleware",
    children: [
      {
        path: "homeMiddleware",
        name: "homeMiddleware",
        component: () => import("@/components/homeMiddleware/homeMiddleware.vue"),
        meta: {

        },
      },
      {
        path: "myTask",
        name: "myTask",
        component: () => import("@/components/myTask/myTask.vue"),
        meta: {
          til: "我的任务_" + process.env.VUE_APP_TITLE_NAME,
        },
      },
      {
        path: "projectHome",
        name: "projectHome",
        redirect: "/home/projectHome/fileList",
        component: () => import("@/components/project/projectHome.vue"),
        children: [
          {
            path: "project",
            component: () => import("@/components/project/project.vue"),
            meta: {
              til: "翻译项目", // 内部属性自定义
            },
            redirect: "/home/projectHome/project/file",
            children: [
              {
                path: "file",
                name: "file",
                component: () => import("@/views/project/file.vue"),
                meta: {
                  til: "新建项目_" + process.env.VUE_APP_TITLE_NAME,
                },
              },
              {
                path: "fileSet",
                name: "fileSet",
                component: () => import("@/views/project/fileSet.vue"),
                meta: {
                  til: "新建项目_" + process.env.VUE_APP_TITLE_NAME,
                },
              },
            ],
          },
          {
            path: "fileList",
            name: "fileList",
            component: () => import("@/components/project/fileList.vue"),
            meta: {
              til: "我的项目_" + process.env.VUE_APP_TITLE_NAME,
            },
          },
          {
            path: "assignInterpreter",
            name: "assignInterpreter",
            component: () => import("@/views/project/assignInterpreter.vue"),
            meta: {
              til: "指定译员_" + process.env.VUE_APP_TITLE_NAME,
            },
          },
          {
            path: "statistics",
            name: "statistics",
            props: true,
            component: () => import("@/views/project/statistics.vue"),
            meta: {
              til: "项目统计_" + process.env.VUE_APP_TITLE_NAME,
            },
          },
          {
            path: "interpreter",
            name: "interpreter",
            props: true,
            component: () => import("@/views/project/interpreter.vue"),
            meta: {
              til: "项目统计_" + process.env.VUE_APP_TITLE_NAME,
            },
          },
          {
            path: "reportForm",
            name: "reportForm",
            props: true,
            component: () => import("@/views/project/reportForm.vue"),
            meta: {
              til: "生产报表_" + process.env.VUE_APP_TITLE_NAME,
            },
          },
          {
            path: "projectParticulars",
            name: "projectParticulars",
            component: () =>
              import("@/views/project/projectParticulars/projectParticulars.vue"),
              meta: {
                til: "项目详情_" + process.env.VUE_APP_TITLE_NAME,
              },
          },
          {
            path: "fileSearch",
            name: "fileSearch",
            component: () => import("@/views/project/fileSearch.vue"),
            meta: {
              til: "文件内容搜索_" + process.env.VUE_APP_TITLE_NAME,
            },
          },
          {
            path: "personageStatistics",
            name: "personageStatistics",
            component: () => import("@/views/project/personageStatistics.vue"),
            meta: {
              til: "译员统计_" + process.env.VUE_APP_TITLE_NAME,
            },
          },
        ],
      },

      {
        path: "memory",
        name: "memory",
        component: () => import("@/components/memory/memory.vue"),
        meta: {
          til: "翻译记忆", // 内部属性自定义
        },
        redirect: "/memory/memoryBank",
        children: [
          {
            path: "memoryBank",
            name: "memoryBank",
            component: () => import("@/views/memory/memoryBank.vue"),
            meta: {
              keepAlive: true,
              til: "翻译记忆_记忆库_" + process.env.VUE_APP_TITLE_NAME,
            },
          },
          {
            path: "termBank",
            name: "termBank",
            component: () => import("@/views/memory/termBank.vue"),
            // keepAlive: true,
            meta: {
              keepAlive: true,
              til: "翻译记忆_术语库_" + process.env.VUE_APP_TITLE_NAME,
            },
          },
          {
            path: "checkTab",
            name: "checkTab",
            component: () => import("@/views/memory/checkTab.vue"),
            meta: {
              keepAlive: false,
              til: "翻译记忆详情_" + process.env.VUE_APP_TITLE_NAME,
            },
            //   props: ()=>{
            //     return{
            //         rowName:'12',
            //         age: 26
            //     }
            // }
            // props: true,
          },
          {
            path: "mergeMemory",
            name: "mergeMemory",
            component: () => import("@/views/memory/mergeMemory.vue"),
            meta: {
              til: "翻译记忆合并_" + process.env.VUE_APP_TITLE_NAME,
            },
          },
          {
            path: "drill",
            name: "drill",
            component: () => import("@/views/memory/drill.vue"),
            meta: {
              til: "增量训练_" + process.env.VUE_APP_TITLE_NAME,
            },
          },
          {
            path: "alignment",
            name: "alignment",
            component: () => import("@/views/memory/alignment.vue"),
            meta: {
              til: "双语对齐_" + process.env.VUE_APP_TITLE_NAME,
            },
          },
          {
            path: "alignmentDetails",
            name: "alignmentDetails",
            component: () => import("@/views/memory/alignmentDetails.vue"),
            meta: {
              til: "双语对齐详情_" + process.env.VUE_APP_TITLE_NAME,
            },
          },
        ],
      },
      {
        path: "manage",
        name: "manage",
        component: () => import("@/components/manage/manage.vue"),
        meta: {
          til: "团队管理_"+ process.env.VUE_APP_TITLE_NAME,
        },
      },
      {
        path: "pay",
        name: "pay",
        component: () => import("@/components/pay/pay.vue"),
        meta: {
          til: "支付中心", // 内部属性自定义
        },
      },
      {
        path: "userConter",
        component: () => import("@/components/userConter/userConter.vue"),
        meta: {
          til: "用户中心_"+ process.env.VUE_APP_TITLE_NAME,
        },
        // hidden: true
      },
      {
        path: "jurisdiction",
        name: "jurisdiction",
        component: () => import("@/components/jurisdiction.vue"),
        // hidden: true
      },
    ],
  },
  {
    path: "/login",
    name: "login", //${process.env.VUE_APP_HOMEPAGE}
    redirect: `/login/login_in`,
    component: () =>
      import(`@/components/login/${process.env.VUE_APP_LOGIN_REDIRECT}.vue`),
    children: [
      {
        path: "login_in",
        name: "login_in",
        component: () => import("@/views/login/login_in.vue"),
        // component: () => import("@/views/login/login_in2.vue"),//新登录页
      },
      {
        path: "login_up",
        name: "login_up",
        component: () => import("@/views/login/login_up.vue"),
      },
      {
        path: "relation",
        name: "relation",
        component: () => import("@/views/login/relation.vue"),
      },
      {
        path: "login_register",
        name: "login_register",
        component: () => import("@/views/login/login_register.vue"),
      },
      {
        path: "wxAddress",
        name: "wxAddress",
        component: () => import("@/views/login/wxAddress.vue"),
      },
    ],
  },
  {
    path: "/autoLogin",
    name: "autoLogin",
    component: () => import("@/views/login/loginAuto.vue"),
  },
  {
    path: "/index",
    name: "homepage",
    component: () => import(`@/components/${process.env.VUE_APP_HOMEPAGE}.vue`),
  },
  {
    path: "/editor",
    name: "editor",
    component: () => import("@/components/editor/editor.vue"),
    meta: {
      til: "译后编辑_"+ process.env.VUE_APP_TITLE_NAME,
    },
    // hidden: true
  },
  {
    path: "/editorXls",
    name: "editorXls",
    component: () => import("@/components/editor/editorXls.vue"),
    meta: {
      til: "译后编辑_"+ process.env.VUE_APP_TITLE_NAME,
    },
    // hidden: true
  },
  {
    path: "/editorTab",
    name: "editorTab",
    component: () => import("@/components/editor/editorTab.vue"),
    meta: {
      til: "译后编辑_"+ process.env.VUE_APP_TITLE_NAME,
    },
    // hidden: true
  },
  {
    path: "/wordEditorTier",
    name: "wordEditorTier",
    component: () => import("@/components/editor/wordEditorTier.vue"),
    meta: {
      til: "译后编辑_"+ process.env.VUE_APP_TITLE_NAME,
    },
    // hidden: true
  },
  {
    path: "/wxLogin",
    component: () => import("@/views/login/wxLogin.vue"),
    // hidden: true
  },
  {
    path: "/publicity",
    component: () => import("@/components/publicity.vue"),
    // hidden: true
  },
  {
    // 用户指引手册
    name: "help",
    path: "/help",
    component: () => import("@/components/help.vue"),
    meta: {
      til: "用户指南_"+ process.env.VUE_APP_TITLE_NAME,
    },
  },
  {
    // 用户指引手册
    name: "help",
    path: "/propaganda",
    component: () => import("@/components/propaganda.vue"),
  },
  {
    path: "*",
    component: () => import("@/components/404.vue"),
    // hidden: true
  },

  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
  // }
];

export default new Router({
  // mode: 'history',
  linkActiveClass: "current",
  // base: process.env.BASE_URL,
  routes,
});
